import React, { useContext } from 'react';
import {
    Home, User, UsersRound, ChartNoAxesCombined, Settings, MessageCircleHeart, LogOutIcon, ServerIcon, ServerCog, CircleDollarSign, CreditCard, Receipt,
    MessageCircleCodeIcon, MailPlus, Mails, Gift,
} from "lucide-react";
import { Link } from 'react-router-dom';
import { useSocket } from '../Context/SocketContext';
import AppContext from '../Context/AppContext';
import { useSupport } from '../Context/SupportContext';

/**
 * Menu du tracker : des libellés (plus seulement des icônes), rangés par thème — Empire (la webapp), Plateformes
 * (PrimeStation…), Serveurs, Réglages. Page ouverte surlignée ; à traiter : pastille (ou nombre) à droite.
 * Mobile : même menu dans un tiroir (bouton menu de l'en-tête ou de la barre du bas).
 */
const SideRight = ({ open = false, onClose = () => { } }) => {
    const { notifAskPaiement, notifPlatformPay, messageUser } = useSocket()
    const { currentPage } = useContext(AppContext)
    const { unread: supportUnread } = useSupport()
    const LogOut = () => {
        localStorage.clear();
        setTimeout(() => {
            window.location.href = '/';
        }, 1000);
    }

    const sections = [
        {
            items: [
                { to: '/', page: 'homepage', label: 'Accueil', Icon: Home },
                { to: '/stat', page: 'stat', label: 'Statistiques', Icon: ChartNoAxesCombined },
            ],
        },
        {
            title: 'Empire', hint: 'webapp',
            items: [
                { to: '/paiement', page: 'paiement', label: 'Paiements', Icon: CircleDollarSign, dot: !!notifAskPaiement },
                { to: '/message_user', page: 'message_user', label: 'Messages', Icon: MessageCircleCodeIcon, dot: !!messageUser },
                { to: '/user_backup', page: 'user_backup', label: 'Users', Icon: User },
            ],
        },
        {
            title: 'Plateformes', hint: 'PrimeStation',
            items: [
                { to: '/user_project', page: 'user_project', label: 'Users', Icon: UsersRound },
                { to: '/paiements_plateformes', page: 'paiements_plateformes', label: 'Paiements', Icon: Receipt, dot: !!notifPlatformPay },
                { to: '/support_plateformes', page: 'support_plateformes', label: 'Support', Icon: MessageCircleHeart, count: supportUnread },
                { to: '/invitations', page: 'invitations', label: 'Invitations', Icon: MailPlus },
                { to: '/emails', page: 'emails', label: 'Emails', Icon: Mails },
                { to: '/parrainage', page: 'parrainage', label: 'Parrainage', Icon: Gift },
            ],
        },
        {
            title: 'Serveurs',
            items: [
                { to: '/server', page: 'server', label: 'Serveurs', Icon: ServerIcon },
                { to: '/server_conf', page: 'server_conf', label: 'Configuration', Icon: ServerCog },
            ],
        },
        {
            title: 'Réglages',
            items: [
                { to: '/parametres_paiement', page: 'parametres_paiement', label: 'Moyens de paiement', Icon: CreditCard },
                { to: '/parametre', page: 'parametre', label: 'Paramètres', Icon: Settings },
            ],
        },
    ]

    return (
        <>
            <div className={`aside-overlay ${open ? "show" : ""}`} onClick={onClose}></div>
            <aside className={`aside-header nav2 bggrad ${open ? "open" : ""}`}>
                <nav className='nav2-main' aria-label='Menu'>
                    {sections.map((s, i) => (
                        <div key={s.title || i} className='nav2-section'>
                            {s.title && (
                                <p className='nav2-title'>
                                    {s.title} {s.hint && <small>· {s.hint}</small>}
                                </p>
                            )}
                            {s.items.map(({ to, page, label, Icon, dot, count }) => (
                                <Link key={to} onClick={onClose} to={to} className={`nav2-item ${currentPage === page ? 'on' : ''}`} aria-current={currentPage === page ? 'page' : undefined}>
                                    <Icon size={19} />
                                    <span className='nav-label'>{label}</span>
                                    {count > 0 ? <span className='nav2-count'>{count > 99 ? '99+' : count}</span> : dot ? <span className='nav2-dot' /> : null}
                                </Link>
                            ))}
                        </div>
                    ))}
                </nav>
                <div className='nav2-bottom'>
                    <button className='nav2-item' onClick={() => LogOut()}>
                        <LogOutIcon size={19} />
                        <span className='nav-label'>Déconnexion</span>
                    </button>
                </div>
            </aside>
        </>
    );
};

export default SideRight;
